import React, {useState} from "react";
import {Col} from "reactstrap";
import {Divider} from "@mui/material";
import {OutlinedInput} from "../../../../../../../base/input/outlined_input";
import Button from "../../../../../../../base/button/button";
import useIsMounted from "../../../../../../../../hooks/use-is-mounted";
import PartAutocomplete from "../../../../../../../text-fields/autocomplete/part-autocomplete";

const AddPartSupportRequestLookupSectionBaseSection = ({
                                                           defineValues,
                                                           lookupValues,
                                                           setLookupValues,
                                                           submitInitialRequest,
                                                       }) => {
    const [addingQuickRGA, setAddingQuickRGA] = useState(false);
    const isMounted = useIsMounted();


    /**
     * Sets the state specific for the Creating a part support request with Quick RGA and calls the provided [submitInitialRequest]
     * callback.
     *
     * @return {Promise<void>}
     */
    const createPartSupportReqWithQuickRGA = async () => {
        setAddingQuickRGA(true);
        setLookupValues(prevState => ({
            ...prevState,
            serialNo: undefined,
            unserializableItemsCount: undefined,
            invoiceNo: undefined,
            selectedQuantity: undefined,
        }));
        await submitInitialRequest(true);
        if (!isMounted())
            return;
        setAddingQuickRGA(false);
    }

    /**
     * Sets the lookup values based on the selected part.
     *
     * - the part can be null in case of a removal.
     * @param {any} part
     */
    const onNewPartSelected = (part) => {
        setLookupValues(previousState => ({
            ...previousState,
            part: !part ? part : {...part, partNo: part.partNo ?? part.partNumber, partNumber: part.partNumber ?? part.partNo},
            isSerialized: false,
        }))
    }

    /**
     * Changes the look-up value for serial number and nullifies the part only if the serial number is an un-empty
     * string.
     * @param newSerial {string | null}
     */
    const onSerialNumberChange = (newSerial) => {
        if (newSerial?.length) {
            setLookupValues(prevState => ({
                ...prevState,
                part: null,
                isSerialized: true,
                serialNumber: newSerial,
            }))
        } else {
            setLookupValues(prevState => ({
                ...prevState,
                serialNumber: newSerial,
            }))
        }
    }

    return (
        <div className={'w-100 row no-gutters p-3'}>
            <Col className={'flex-grow-1 d-flex flex-column'}>
                <PartAutocomplete
                    fullWidth
                    label={"Product"}
                    value={lookupValues?.part}
                    onChange={(_, value) => onNewPartSelected(value)}
                    getOptionLabel={v => v?.partNumber ?? v?.partNo ?? ''}
                    isOptionEqualToValue={(option, value) => (option?.partNumber ?? option?.partNo) === (value?.partNumber ?? value?.partNo)}
                />
                {
                    (!!lookupValues?.part && !defineValues?.inventoryBased) &&
                    <Button
                        disabled={addingQuickRGA}
                        className='py-2-5 px-4 mx-auto my-2'
                        variant={'dialog'}
                        color={'primary'}
                        onClick={createPartSupportReqWithQuickRGA}
                    >
                        {
                            addingQuickRGA
                                ? "Loading"
                                : "Add without Further Information"
                        }
                    </Button>
                }
            </Col>
            <Divider className={'vertical-divider large mx-4'}/>
            <Col className={'flex-grow-1'}>
                <OutlinedInput
                    label={'Serial Number'}
                    value={lookupValues?.serialNumber ?? ''}
                    onChange={onSerialNumberChange}

                />
            </Col>
        </div>
    )
}

export default AddPartSupportRequestLookupSectionBaseSection;
